<template>
    <div class="tile is-parent">
        <article class="tile is-child box">
            <p class="title">编辑规则</p>
            <div class="block">
                <span>活动期间加车次数=</span>
                <input tyoe="number" class="input width-2" v-model.number="params.count"/>
            </div>
            <p class="title">奖品</p>
            <div class="block" style="width: 1200px">
                <table class="table is-bordered">
                    <thead>
                    <tr>
                        <th class="mini-width">
                            <input type="checkbox" v-model="isSelectedAll" @click="onCheckAll">
                        </th>
                        <th>奖品ID</th>
                        <th>奖品名称</th>
                        <th>剩余数量</th>
                        <th>概率权重</th>
                        <th>实际概率</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in params.list">
                        <td class="mini-width"><input type="checkbox" v-model="item.isSelected" @click="onCheckOne(index)"/></td>
                        <td>{{ item.prizeId }}</td>
                        <td>{{item.title}}</td>
                        <td>{{item.remainCount}}</td>
                        <td><input type="number" class="width-1"  v-model.number="item.weight" ></td>
                        <td>{{item.rate}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <p class="title">达到条件弹窗</p>
            <el-upload
                    class="avatar-uploader"
                    :action="server"
                    :show-file-list="false"
                    name="image"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                <div class="info"><el-button class="floatl" size="small" type="primary">点击上传</el-button><div  slot="tip" class="el-upload__tip floatl" style="color: red;font-size: 15px">只能上传jpg/png文件，且不超过500kb【建议宽高尺寸 600px * 764px】</div></div>
                <image-component :image="params.image" :width="300"></image-component>

            </el-upload>
            <div class="block">
                <button class="button" @click="cancelEdit">取消</button>
                <button class="button is-info" @click="saveEdit" style="margin-left: 30px;">保存</button>
            </div>
        </article>
    </div>
</template>
<script type="text/babel">
export default {
  data () {
    return {
      activityId: null,
      ruleId: 0,
      params: {
        count: 0,
        list: [],
        image: {
          image: '',
          width: 0,
          height: 0
        }
      },
      imageUrl: '',
      options: [{
        value: 1,
        label: '奖卷'
      }, {
        value: 2,
        label: '其他'
      }],
      isSelectedAll: 0
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      console.log(this.$route.query.activityId)
      this.activityId = parseInt(this.$route.query.activityId)
      if (this.$route.query.ruleId) {
        this.ruleId = parseInt(this.$route.query.ruleId)
      }
      this.getRuleList()
    })
  },
  computed: {
    server () {
      return process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage'
    }
  },
  methods: {
    onCheckAll () {
      setTimeout(() => {
        if (this.isSelectedAll) {
          _.each(this.params.list, item => {
            item.isSelected = 1
          })
        } else {
          _.each(this.params.list, item => {
            item.isSelected = 0
          })
        }
      }, 0)
    },
    onCheckOne (index) {
      setTimeout(() => {
        if (!this.params.list[index].isSelected) {
          this.isSelectedAll = 0
          return false
        }
        for (let i = 0, len = this.params.list.length; i < len; i++) {
          if (!this.params.list[i].isSelected) {
            this.isSelectedAll = 0
            return false
          }
        }
        this.isSelectedAll = 1
      }, 0)
    },
    handleAvatarSuccess (response, file) {
      this.params.image.image = response.data.images.info.path
      this.params.image.width = response.data.images.info.width
      this.params.image.height = response.data.images.info.height
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png'
      const isLt2M = file.size / 1024 < 500

      if (!isJPG) {
        this.$message('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt2M
    },

    // 获取专题分类详情
    getRuleList () {
      HttpRequest.get('/admin.php?method=cartactivity.getRule', {activityId: this.activityId, ruleId: this.ruleId}, true).then((response) => {
        if (!this.ruleId) {
          this.params.list = response.data.list
        } else {
          this.params = response.data
        }
      }, (response) => {
      })
    },

    // 保存编辑
    saveEdit () {
      //                let params = Object.assign({},this.params);

      /* if(!this.params.count){
                    this.$message("请输入活动期间加车次数");
                    return
                } */
      if (!this.params.image.image) {
        this.$message('请上传图片')
        return
      }
      let params = {
        activityId: this.activityId,
        ruleId: this.ruleId,
        count: this.params.count,
        prizeWeights: [],
        image: this.params.image
      }
      _.each(this.params.list, item => {
        if (item.isSelected) {
          params.prizeWeights[item.prizeId] = item.weight
        }
      })
      console.log('123', params)
      HttpRequest.post('/admin.php?method=cartactivity.doSaveRule', params, true).then((response) => {
        this.$message('保存成功', 1000)
        setTimeout(() => {
          this.$router.push({name: 'addCartRuleConfig', query: {activityId: this.activityId}})
        })
      }, (response) => {

      })
    },
    cancelEdit () {
      this.$router.push({name: 'addCartRuleConfig', query: {activityId: this.activityId}})
    }
  }
}
</script>
<style lang="less" scoped>
    /*.upload-img-tips{*/
    /*position: relative;*/
    /*top: 10px;*/
    /*color: #ff0000;*/
    /*}*/
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .info{
        height:35px;
        .floatl{
            float: left;
        }
    }
    .add{

    }
</style>
